export default __webpack_public_path__ + "pdf/Blake_Sweeney.01c76a8.pdf";